export default __webpack_public_path__ + "static/media/avatar-5.364c1f11.jpg";